export default "__VITE_ASSET__De9DQqid__"